module.exports = __webpack_public_path__ + "static/media/loader_thin.06fc2cc4.svg";